import { TeamOutlined } from "@ant-design/icons";
import { Link } from "@tanstack/react-router";
import { Button, Result } from "antd";
import { PartnersCatalogTable } from "components/Tables/PartnersCatalogTable/PartnersCatalogTable";
import { AccountPage } from "components/UI/AccountPage/AccountPage.tsx";
import { SectionContentWrapper } from "components/UI/SectionContentWrapper";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { useUser } from "hooks/useUser";
import { PermissionEnum } from "types/enums";
import { getPartnersCatalogHeaderItems } from "utils/accountHeaderItems.ts";
import { createAccountFileRoute } from "utils/createAccountFileRoute.ts";

export const Route = createAccountFileRoute("/_authenticated/account/_layout/partners/")({
    component: PartnersCatalogPage,
    staticData: {
        permissions: [PermissionEnum.PartnerView],
        isPublic: true,
        showInSideMenu: true,
        label: "pages.account.partners-catalog.title",
        icon: <TeamOutlined />,
        sort: 3,
    },
    loader: ({ context: { t } }) => ({
        breadcrumb: t("pages.account.partners-catalog.title"),
    }),
});

export function PartnersCatalogPage() {
    const { t } = usePaldockTranslation("pages.account.partners-catalog");
    const userUtils = useUser();
    const canInvitePartners = userUtils.hasPermissionInAnyTenant(PermissionEnum.UserRequestUpdate);

    return (
        <AccountPage headerNavigationItems={getPartnersCatalogHeaderItems}>
            <SectionContentWrapper withBackground className={canInvitePartners ? "!p-0" : undefined}>
                {canInvitePartners ? (
                    <PartnersCatalogTable />
                ) : (
                    <div className="mx-auto my-auto py-8">
                        <Result
                            status="info"
                            title={t("guard.title")}
                            subTitle={t("guard.subtitle")}
                            extra={
                                <Link to="/account">
                                    <Button type="primary">{t("guard.action")}</Button>
                                </Link>
                            }
                        />
                    </div>
                )}
            </SectionContentWrapper>
        </AccountPage>
    );
}
